import React, { useEffect, useState } from 'react';
import deals from '../media/h1.webp';
import Features from './Features';
import FeaturedCat from './FeaturedCat';
import NewArrivals from './NewArrivals';
import about from '../media/sailboat.webp'
import { Link, useNavigate } from 'react-router-dom';
import Motherhood from './Motherhood';
import FollowUs from './FollowUs';
import Testimonial from './Testimonial';

export default function () {
    const navigate = useNavigate();

    return (
        <div className='Home' style={{ overflowX: 'hidden', naxWidth: '100%' }}>
            <FeaturedCat />
             <NewArrivals />
            <Features />

            <div className='container'>
                <div className='deals row'>
                {window.innerWidth <= 576 && <div className='col-xs-6 image'>
                    <img src={deals} alt="" />
                </div>}
                <div className='col-xs-6' style={{ background: 'white' }}>
                    <p className='head'>
                        Kidorise – Everything your baby needs, with love and care.
                    </p>
                    <p className='content'>
                        <ul >
                            <li> Designer product range</li>
                            <li>Moderate pricing policy</li>
                            <li>Variegated variety</li>
                            <li>Ethical business practices and transparent dealings</li>
                            <li>Standardized packaging</li>
                        </ul>
                    </p>
                    <div className='button'><Link className='btn-cart welcome-add-cart text-center' to='/collection/all'>Buy Now</Link></div>
                </div>
                {window.innerWidth > 576 && <div className='col-xs-6 image'>
                    <img src={deals} alt=""  onClick={()=> navigate('/collection/all')}/>
                </div>}
            </div>
            </div>
            <div className='container' style={{paddingBottom:'78px'}}>
                <div className='aboutus row'>
                <div className='col-xs-6 image'>
                    <img src={about} alt="" />
                </div>
                <div className='col-xs-6'>
                    <p className='head'>About Us</p>
                    <p className='content'>
                        { window.innerWidth>768 && "There’s no denying that the right kind of baby products can truly uplift your little one’s world! Add comfort and charm to your nursery with baby essentials and accessories that match your parenting style. Whether you're into soft, traditional designs, or prefer a more modern, playful approach to baby care, or anything in between, be sure to check out Kidorise’s vast collections of baby offerings and infant essentials. In addition, they make ideal gifts for new parents when shopping for loved ones! From Baby Care to Nursery Decor, Feeding Accessories to Toys, our baby products will turn your baby’s space into a cozy haven!"}
                        {window.innerWidth<=768 && "The right baby products can truly uplift your little one’s world! Explore Kidorise for essentials and accessories that match your parenting style—traditional, modern, or anything in between. From baby care and nursery decor to feeding accessories and toys, our curated collection also makes perfect gifts for new parents!"}
                    </p>
                    <div className='button'><Link className='btn-cart welcome-add-cart text-center' to='/about'>Know More</Link></div>
                </div>
            </div>
            </div>
           
            {/* <OurServices /> */}
            <Motherhood />
            <FollowUs />
            <Testimonial />
        </div>
    )
}
